import React from 'react';

import { BaseIconProps } from '.';

export const Checkmark = ({ fill }: BaseIconProps) => (
  <g
    transform="matrix(84.079778,0,0,84.079778,727.35246,-2322.6318)"
    strokeWidth="0.01189347"
  >
    <path
      fill={fill}
      strokeWidth="0.01189347"
      d="m -7.2498707,33.143047 -1.4008712,1.596987 4.6597456,4.528876 8.1851979,-8.999696 -1.5592247,-1.444894 -6.7848986,7.391724 z"
    />
  </g>
);
